import { createWebPersistentMap } from "./persistent"

export interface UtmParams {
  utmCampaign?: string | null
  utmContent?: string | null
  utmMedium?: string | null
  utmSource?: string | null
  utmTerm?: string | null
}

export const $utm = createWebPersistentMap<UtmParams>("utm:", {})

export const updateUtm = (utm: UtmParams) => {
  $utm.set(utm)
}

export const resetUtm = () => {
  $utm.set({
    utmCampaign: null,
    utmContent: null,
    utmMedium: null,
    utmSource: null,
    utmTerm: null,
  })
}
